import { Prescription, PrescriptionDetail } from '../../types';

// Mock prescriptions database
export let mockPrescriptions: Prescription[] = [
  {
    id: '1',
    code: '79bdxF0CD707-c',
    doctorName: 'Nguyễn Thanh Vũ',
    patientName: 'Nguyễn Cẩm Nhung',
    diagnosis: 'Viêm amyđan quá phát độ 2',
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
    status: 'sent',
    invoiceStatus: 'exported',
    totalAmount: 95000,
    tax: 0,
    totalRevenue: 95000,
  },
  {
    id: '2',
    code: '79bdx2A4C6CA-c',
    doctorName: 'Nguyễn Thanh Vũ',
    patientName: 'Nguyễn Cẩm Nhung',
    diagnosis: 'Viêm amyđan quá phát độ 2',
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
    status: 'sent',
    invoiceStatus: 'exported',
    totalAmount: 95000,
    tax: 0,
    totalRevenue: 95000,
  },
  {
    id: '3',
    code: '79bdx9B9CD07-c',
    doctorName: 'Nguyễn Thanh Vũ',
    patientName: 'Nguyễn Cẩm Nhung',
    diagnosis: 'Viêm amyđan quá phát độ 2',
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
    status: 'sent',
    invoiceStatus: 'exported',
    totalAmount: 95000,
    tax: 0,
    totalRevenue: 95000,
  },
  {
    id: '4',
    code: '79bdxD2AF846-c',
    doctorName: 'Nguyễn Thanh Vũ',
    patientName: 'Nguyễn Cẩm Nhung',
    diagnosis: 'Viêm amyđan quá phát độ 2',
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
    status: 'sent',
    invoiceStatus: 'exported',
    totalAmount: 95000,
    tax: 0,
    totalRevenue: 95000,
  },
  {
    id: '5',
    code: '79bdx9074674-c',
    doctorName: 'Nguyễn Thanh Vũ',
    patientName: 'Nguyễn Cẩm Nhung',
    diagnosis: 'Viêm amyđan quá phát độ 2',
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
    status: 'sent',
    invoiceStatus: 'exported',
    totalAmount: 95000,
    tax: 0,
    totalRevenue: 95000,
  },
  {
    id: '6',
    code: '79bdxA1B2C3D4-c',
    doctorName: 'Nguyễn Thanh Vũ',
    patientName: 'Nguyễn Cẩm Nhung',
    diagnosis: 'Viêm amyđan quá phát độ 2',
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
    status: 'sent',
    invoiceStatus: 'exported',
    totalAmount: 95000,
    tax: 0,
    totalRevenue: 95000,
  },
  {
    id: '7',
    code: '79bdxE5F6G7H8-c',
    doctorName: 'Nguyễn Thanh Vũ',
    patientName: 'Nguyễn Cẩm Nhung',
    diagnosis: 'Viêm amyđan quá phát độ 2',
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
    status: 'sent',
    invoiceStatus: 'exported',
    totalAmount: 95000,
    tax: 0,
    totalRevenue: 95000,
  },
  {
    id: '8',
    code: '79bdxI9J0K1L2-c',
    doctorName: 'Nguyễn Thanh Vũ',
    patientName: 'Nguyễn Cẩm Nhung',
    diagnosis: 'Viêm amyđan quá phát độ 2',
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
    status: 'sent',
    invoiceStatus: 'exported',
    totalAmount: 95000,
    tax: 0,
    totalRevenue: 95000,
  },
  {
    id: '9',
    code: '79bdxM3N4O5P6-c',
    doctorName: 'Nguyễn Thanh Vũ',
    patientName: 'Nguyễn Cẩm Nhung',
    diagnosis: 'Viêm amyđan quá phát độ 2',
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
    status: 'sent',
    invoiceStatus: 'exported',
    totalAmount: 95000,
    tax: 0,
    totalRevenue: 95000,
  },
  {
    id: '10',
    code: '79bdxQ7R8S9T0-c',
    doctorName: 'Nguyễn Thanh Vũ',
    patientName: 'Nguyễn Cẩm Nhung',
    diagnosis: 'Viêm amyđan quá phát độ 2',
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
    status: 'sent',
    invoiceStatus: 'exported',
    totalAmount: 95000,
    tax: 0,
    totalRevenue: 95000,
  },
  {
    id: '11',
    code: '79bdxU1V2W3X4-c',
    doctorName: 'Nguyễn Thanh Vũ',
    patientName: 'Nguyễn Cẩm Nhung',
    diagnosis: 'Viêm amyđan quá phát độ 2',
    createdAt: '2025-11-25T09:25:00',
    sentDate: '2025-11-25T10:25:00',
    status: 'sent',
    invoiceStatus: 'exported',
    totalAmount: 95000,
    tax: 0,
    totalRevenue: 95000,
  },
];

// Mock prescription details
export const mockPrescriptionDetails: Record<string, PrescriptionDetail> = {
  '79bdxF0CD707-c': {
    id: '1',
    code: '79bdxF0CD707-c',
    doctorName: 'Nguyễn Thanh Vũ',
    patientName: 'Nguyễn Cẩm Nhung',
    diagnosis: 'Viêm amyđan quá phát độ 2',
    createdAt: '2025-11-25',
    status: 'sent',
    invoiceStatus: 'exported',
    totalAmount: 195500,
    tax: 0,
    totalRevenue: 195500,
    patientInfo: {
      fullName: 'NGUYỄN THANH VŨ',
      address: '150 Phạm Hùng, Thành phố Hồ Chí Minh',
      idCard: '07912345678',
    },
    services: [
      { name: 'Khám Tai Mũi Họng', amount: 80000 },
      { name: 'Tiền thuốc', amount: 115500 },
    ],
    medicines: [
      {
        name: 'Paracetamol 325mg + Ibuprofen 200mg (Ibucet)',
        quantity: '6 Viên',
        instructions: 'Uống: sáng 1 viên, tối 1 viên, Uống 1 viên khi đau nhức hoặc sốt',
      },
      {
        name: 'Fexofenadin 60mg (Fexofenadin 60-US)',
        quantity: '3 Viên',
        instructions: 'Uống: tối 1 viên',
      },
      {
        name: 'Cefdinir 300mg (Akudinir-300)',
        quantity: '6 Viên',
        instructions: 'Uống: sáng 1 viên, tối 1 viên',
      },
      {
        name: 'Esomeprazol 20mg (Esomex-20)',
        quantity: '3 Viên',
        instructions: 'Uống: sáng 1 viên',
      },
      {
        name: 'Eucalypton + Ginger (EucaFast)',
        quantity: '6 Viên',
        instructions: 'Uống: sáng 1 viên, tối 1 viên',
      },
      {
        name: 'Natri clorid 0,9% + Nano Ag + Keo ong (Amysat (xanh))',
        quantity: '1 Chai',
        instructions: 'Xịt mũi: sáng 2 xịt, trưa 2 xịt, chiều 2 xịt, tối 2 xịt',
      },
    ],
    paymentMethod: 'Tiền mặt',
  },
};

